"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notifier = void 0;
const queue_microtask_1 = __importDefault(require("queue-microtask"));
const error_1 = require("./error");
class Notifier {
    constructor() {
        this.notificationQueue = new Set;
        this.notificationTrace = new Set;
        this.willNotifyThisTick = false;
    }
    enqueue(set) {
        if (this.notificationQueue.has(set)) {
            return;
        }
        if (this.notificationTrace.has(set)) {
            const trace = [...this.notificationTrace, set]
                .map(observer => `"${observer.name}"`)
                .join(' -> ');
            throw new error_1.EcceError('Recursive observers: ' + trace);
        }
        this.notificationQueue.add(set);
        if (!this.willNotifyThisTick) {
            this.willNotifyThisTick = true;
            (0, queue_microtask_1.default)(() => {
                try {
                    this.notify();
                }
                finally {
                    this.willNotifyThisTick = false;
                    this.notificationQueue.clear();
                    this.notificationTrace.clear();
                }
            });
        }
    }
    notify() {
        const toNotify = [...this.notificationQueue];
        this.notificationQueue.clear();
        for (const set of toNotify) {
            this.notificationTrace.add(set);
            for (const observer of set) {
                observer();
                /*
                    If notifying the observer resulted in more Observers being enqueued
                    for notification, notify them immediately. This allows us to catch
                    recursive observer chains.
                */
                if (this.notificationQueue.size) {
                    this.notify();
                }
            }
            this.notificationTrace.delete(set);
        }
    }
}
exports.Notifier = Notifier;
//# sourceMappingURL=notifier.js.map